export default __webpack_public_path__ + "static/media/honda.0989958a.png";